export const LOADING_EVALUATION_TYPE = "LOADING_EVALUATION_TYPE";
export const SAVE_LOADING_EVALUATION_TYPE = "SAVE_LOADING_EVALUATION_TYPE";
export const GET_EVALUATION_TYPE = "GET_EVALUATION_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const EVALUATION_TYPE_FAIL = "EVALUATION_TYPE_FAIL";
export const LOADING_EVALUATION_TYPE_BY_ID = "LOADING_EVALUATION_TYPE_BY_ID";
export const GET_EVALUATION_TYPE_BY_ID = "GET_EVALUATION_TYPE_BY_ID";

